import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-gold-play",
  "use": "spr-gold-play-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 80 80\" id=\"spr-gold-play\"><defs><path id=\"spr-gold-play_a\" d=\"M536 2016c-22.06 0-40-17.94-40-40s17.94-40 40-40 40 17.94 40 40-17.94 40-40 40zm0-78c-20.95 0-38 17.05-38 38s17.05 38 38 38 38-17.05 38-38-17.05-38-38-38zm-9 53.16a1 1 0 0 1-1-1v-28.26a1 1 0 0 1 1.56-.83l21.2 14.55a1 1 0 0 1-.02 1.66l-6.74 4.36a1 1 0 0 1-1.09-1.68l5.48-3.54-18.4-12.62v24.52l1.92-1.24a1 1 0 1 1 1.09 1.68l-3.46 2.24a1 1 0 0 1-.54.16zm6.46-4.18a1 1 0 0 1-.55-1.84l5-3.23a1 1 0 1 1 1.09 1.68l-5 3.23a1 1 0 0 1-.54.16z\" /></defs><use fill=\"#cd9932\" xlink:href=\"#spr-gold-play_a\" transform=\"translate(-496 -1936)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/gold-play.svg
// module id = 258
// module chunks = 0